import Cookie from 'js-cookie';

import { COOKIE_LANG } from '../../constants/Common';

import { TLangFile, ILocaleComplement, TLocaleInfo } from './Lang.type';
import { getCatalog, isKnownLang, TLangKey } from './localeCatalog';

export const getComplement = (lang: string | undefined) => {
    const langFinal = lang || Cookie.get(COOKIE_LANG);

    const langDTO: Record<string, ILocaleComplement> = {
        'es': {
            locale: 'es',
            dateFormat: {
                complete: 'L',
                dayAndMonth: 'DD/MM'
            }
        },

        'en_us': {
            locale: 'en-US',
            dateFormat: {
                complete: 'MM/DD/yyyy',
                dayAndMonth: 'MM/DD'
            }
        },

        'fr': {
            locale: 'fr',
            dateFormat: {
                complete: 'DD/MM/yyyy',
                dayAndMonth: 'DD/MM'
            }
        },

        'it': {
            locale: 'it',
            dateFormat: {
                complete: 'DD/MM/yyyy',
                dayAndMonth: 'DD/MM'
            }
        },

        'de': {
            locale: 'de',
            dateFormat: {
                complete: 'DD/MM/yyyy',
                dayAndMonth: 'DD/MM'
            }
        },

        'pt_br': {
            locale: 'pt-BR',
            dateFormat: {
                complete: 'DD/MM/yyyy',
                dayAndMonth: 'DD/MM'
            }
        },

        default: {
            locale: 'en-US',
            dateFormat: {
                complete: 'MM/DD/yyyy',
                dayAndMonth: 'MM/DD'
            }
        }
    };

    return langDTO[langFinal || 'default'] || langDTO.default;
};

/**
 * Memo por idioma, junto com o catálogo que o originou — ver `getLocaleInfo`.
 */
const localeInfoMemo = new Map<TLangKey | 'default', { catalog: TLangFile; info: TLocaleInfo }>();

/**
 * Função extraída para evitar Dependency cycle loop com Utils.js
 *
 * O memo é invalidado pela identidade do catálogo, não pelo idioma: até o `import()` do locale
 * chegar, `getCatalog` devolve o embutido, e a entrada memoizada travaria o usuário em pt-BR.
 */
export const getLocaleInfo = (forceLang?: string): TLocaleInfo => {
    const lang = forceLang || Cookie.get(COOKIE_LANG);
    const key = isKnownLang(lang) ? lang : 'default';
    const catalog = getCatalog(lang);

    const memoized = localeInfoMemo.get(key);
    if (memoized && memoized.catalog === catalog) return memoized.info;

    const info = { ...catalog, ...getComplement(lang) } as TLocaleInfo;
    localeInfoMemo.set(key, { catalog, info });

    return info;
};
